import { useEffect, useRef } from 'react';

// Third party
import { useNavigate } from 'react-router-dom';

// Hooks
import { useLogoutAPI } from './API/welcome';

const useCrossTabAuthSync = () => {
  const navigate = useNavigate();
  const { clearAppState } = useLogoutAPI();

  const lastTokenRef = useRef<string | null>(localStorage.getItem('authToken'));
  const isHandlingRef = useRef(false);

  useEffect(() => {
    const onStorage = async (event: StorageEvent) => {
      if (event.key !== 'authToken') return;

      const newToken = event.newValue;
      const oldKnownToken = lastTokenRef.current;

      if (newToken === oldKnownToken || isHandlingRef.current) return;

      isHandlingRef.current = true;
      lastTokenRef.current = newToken;

      try {
        await clearAppState();

        if (!newToken) {
          navigate('/login', { replace: true });
          return;
        }

        window.location.reload();
      } finally {
        isHandlingRef.current = false;
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [clearAppState, navigate]);
};

export { useCrossTabAuthSync };